const { q } = require('../helpers.js');

export const txtVehicleVin = q('#txtVehicleVin');
export const btnVehicleVinTooltip = q('#btnVehicleVinTooltip');
export const ddlVehicleClass = q('#ddlVehicleClass');
export const ddlVehicleBrand = q('#ddlVehicleBrand');
export const ddlVehicleModel = q('#ddlVehicleModel');
export const txtVehicleMaxWeight = q('#txtVehicleMaxWeight');
export const txtVehicleYear = q('#txtVehicleYear');
export const txtVehicleSeatNo = q('#txtVehicleSeatNo');
export const txtVehicleEnginePower = q('#txtVehicleEnginePower');
export const txtVehicleEngineDisplacement = q('#txtVehicleEngineDisplacement');
export const ddlVehicleEnergySource = q('#ddlVehicleEnergySource');
export const txtVehiclePlateNo = q('#txtVehiclePlateNo');
export const btnVehicleNext = q('#btnVehicleNext');

export const promoTextCar = q('.step-1 .promo-text-car');
export const promoLinkCar = q('.step-1 .promo-link-car');

export const btnVehicleTaxiTooltip = q('#btnVehicleTaxiTooltip');
export const divTaxi = q('#divTaxi');
export const btnVehicle1Next = q('#btnVehicle1Next');
export const btnVehicle1Back = q('#btnVehicle1Back');